<template>
  <div id="game" >
    <TitleScreen :title="gameTitle" @gamestate="updateGame" v-if="status === 'starting' " />
    <MainState v-if="status === 'running'" @gamestate="updateGame" @found="saveFoundModels" :searchRounds="rounds" />
    <FinalScreen v-if="status === 'over'" @gamestate="updateGame" :ModelsFound="foundModels" :searchedRounds="rounds" />
  </div>
</template>

<script>
import styles from './scss/main.scss'

const TitleScreen = () => import('./components/TitleScreen.vue')
const MainState = () => import('./components/MainState.vue')
const FinalScreen = () => import('./components/FinalScreen.vue')

export default {
  name: 'game',
  data: function () {
    return {
      status,
      foundModels: null,
      rounds: window.options.settings.round_limit,
      gameTitle: window.config.text.intro.title
    }
  },
  components: {
    styles,
    TitleScreen,
    MainState,
    FinalScreen
  },
  methods: {
    updateGame(state){
      this.status = state;
      if(this.status == 'restart'){
        this.$forceUpdate();
        this.status = 'running';
      }
    },
    initialize(){
      this.status = 'starting';
    },
    saveFoundModels(models){

      this.foundModels = models;

    }

  },
  created: function(){
    this.initialize();
  }
}
</script>
